import type { ApiClient } from './client.js';
import type {
  AddYoutubeVideoBody,
  ReorderYoutubeVideosBody,
  YoutubeSearchResultDto,
  YoutubeVideoDto,
} from './types.js';

export interface YoutubeApi {
  listVideos(classroomId: string): Promise<YoutubeVideoDto[]>;
  addVideo(classroomId: string, body: AddYoutubeVideoBody): Promise<YoutubeVideoDto>;
  removeVideo(classroomId: string, videoId: string): Promise<void>;
  reorderVideos(classroomId: string, body: ReorderYoutubeVideosBody): Promise<YoutubeVideoDto[]>;
  search(classroomId: string, query: string, date: string): Promise<YoutubeSearchResultDto[]>;
}

export function createYoutubeApi(client: ApiClient): YoutubeApi {
  return {
    async listVideos(classroomId) {
      const res = await client.get<{ videos: YoutubeVideoDto[] }>(
        `/api/classrooms/${classroomId}/youtube/videos`,
      );
      return res.videos;
    },
    async addVideo(classroomId, body) {
      const res = await client.post<{ video: YoutubeVideoDto }>(
        `/api/classrooms/${classroomId}/youtube/videos`,
        body,
      );
      return res.video;
    },
    async removeVideo(classroomId, videoId) {
      await client.delete(`/api/classrooms/${classroomId}/youtube/videos/${videoId}`);
    },
    async reorderVideos(classroomId, body) {
      const res = await client.put<{ videos: YoutubeVideoDto[] }>(
        `/api/classrooms/${classroomId}/youtube/videos/reorder`,
        body,
      );
      return res.videos;
    },
    async search(classroomId, query, date) {
      const params = new URLSearchParams({ q: query, date });
      const res = await client.get<{ results: YoutubeSearchResultDto[] }>(
        `/api/classrooms/${classroomId}/youtube/search?${params.toString()}`,
      );
      return res.results;
    },
  };
}
